import { Link } from '@tanstack/react-router'
import { Home, TrendingUp } from 'lucide-react'
import { useEffect, useMemo } from 'react'
import { useAuthStore } from '@/features/auth/stores/authStore'
import { PageTitle } from '@/shared/components/common/PageTitle'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/shared/components/ui/breadcrumb'
import { Button } from '@/shared/components/ui/button'
import { useBreadcrumbs } from '@/shared/hooks/useBreadcrumbs'
import { GettingStarted } from './GettingStarted'

export default function DashboardPage() {
  const { user } = useAuthStore()
  const { setBreadcrumbs } = useBreadcrumbs()

  const breadcrumbsContent = useMemo(
    () => (
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage className='flex items-center gap-1'>
              <Home className='w-4 h-4' />
              Dashboard
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    ),
    []
  )

  useEffect(() => {
    setBreadcrumbs(breadcrumbsContent)
  }, [setBreadcrumbs, breadcrumbsContent])

  return (
    <div className='container mx-auto py-6'>
      <div className='space-y-6'>
        {/* Header */}
        <div className='flex items-center justify-between'>
          <PageTitle
            title='Dashboard'
            subtitle={`Welcome back${user?.email ? `, ${user.email}` : ''}! Set up your agent monetization platform.`}
          />
          <Link to='/monetization-dashboard'>
            <Button className='flex items-center gap-2'>
              <TrendingUp className='h-4 w-4' />
              View Monitization Dashboard
            </Button>
          </Link>
        </div>

        {/* Main Content */}
        <div className='max-w-2xl mx-auto'>
          <GettingStarted />
        </div>
      </div>
    </div>
  )
}
